import {
  AppBar as MuiAppBar,
  Toolbar,
  Typography,
  Chip,
  IconButton,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { CloudOff, ArrowBack } from '@mui/icons-material';
import { useOfflineStatus } from '@hooks/useOfflineStatus';
import { useTranslation } from 'react-i18next';

export function AppBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const isOffline = useOfflineStatus();
  const { t } = useTranslation();

  const getPageTitle = () => {
    if (location.pathname === '/') return t('appBar.home');
    if (location.pathname.includes('/session/new')) return t('appBar.newSession');
    if (location.pathname.includes('/observe')) return t('appBar.observation');
    if (location.pathname.includes('/review')) return t('appBar.sessionSummary');
    if (location.pathname === '/sessions') return t('appBar.activeSessions');
    if (location.pathname.includes('/settings')) return t('appBar.settings');
    return t('appBar.home');
  };

  // Back button only on pages that aren't main nav destinations or session pages
  const showBackButton =
    location.pathname !== '/' &&
    !location.pathname.includes('/session/new') &&
    location.pathname !== '/sessions' &&
    !location.pathname.includes('/observe') &&
    !location.pathname.includes('/review') &&
    !location.pathname.includes('/settings');

  return (
    <MuiAppBar position="sticky" elevation={1}>
      <Toolbar>
        {showBackButton && (
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => navigate(-1)}
            sx={{ mr: 1 }}
            aria-label={t('common.back')}
          >
            <ArrowBack />
          </IconButton>
        )}

        <Typography
          variant="h6"
          component="div"
          sx={{ fontWeight: 600, flexGrow: 1 }}
        >
          {getPageTitle()}
        </Typography>

        {isOffline && (
          <Chip
            icon={<CloudOff />}
            label={t('common.offline')}
            size="small"
            color="warning"
            sx={{ fontWeight: 500 }}
          />
        )}
      </Toolbar>
    </MuiAppBar>
  );
}
